export default "__VITE_ASSET__AXQol2q5__"